import React, { FC, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Text } from '../text'

export type TimeDividerProps = {
    /** Time label shown between the two rules, e.g. `14:42`. */
    time: ReactNode
    className?: string
    testID?: string
}

/**
 * Horizontal time separator for the flight/towing lists (Figma node
 * 10350:69778): a short 24px leading rule, a P3 medium time label, then a
 * hairline rule that fills the remaining width. The rules are `graphics/grey`
 * and the label `content/default` — the action blue it used to carry was the
 * pre-redesign colour. (AOS-631, AOS-1359)
 */
export const TimeDivider: FC<TimeDividerProps> = ({ time, className, testID }) => (
    <Box className={twMerge('h-5 flex-row items-center gap-2', className)} testID={testID}>
        <Box className='h-px w-6 bg-graphics-grey' />
        <Text size='caption' weight='medium' className='whitespace-nowrap'>
            {time}
        </Text>
        <Box className='h-px flex-1 bg-graphics-grey' />
    </Box>
)

TimeDivider.displayName = 'TimeDivider'
